export default function initVideo() {
    // Play video
    const videoElement = document.querySelector("#video-file");
    const videoYoutube = document.querySelector("#video-youtube");
    const playButton = document.querySelector("#play-video")
    const videoTitle = document.querySelector(".video-title")
    const videoPoster = document.querySelector("#video-poster")

    if (playButton && (videoElement || videoYoutube)) {
        const playButtonElem = playButton.querySelector('button')
        playButtonElem.addEventListener("click", () => {
            if (videoElement) {
                videoElement.setAttribute("controls", "")
                playButton.classList.add("hidden")
                videoElement.play()
                videoTitle.classList.add("lg:hidden")
            }

            if (videoYoutube) {
                videoYoutube.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
                videoPoster.classList.add("hidden")
                playButton.classList.add("hidden")
                videoTitle.classList.add("lg:hidden")
            }
        })
    }
}